/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * App config: auth0 Config.
 */

import authConfigJson from '../auth0Config.json';

/**
 * Auth0 settings. Prefer REACT_APP_* env vars at build time;
 * auth0Config.json is copied per environment in Docker builds.
 */
export const auth0Config = {
    domain: process.env.REACT_APP_AUTH0_DOMAIN || authConfigJson.domain,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || authConfigJson.clientId,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE || authConfigJson.audience,
    callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL || authConfigJson.callback_url,
};
